import React from 'react'

const Search = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M10.5 1C15.7467 1 20 5.25329 20 10.5C20 12.7631 19.2068 14.8398 17.8857 16.4717L21.833 20.4189C22.2231 20.8095 22.2234 21.4426 21.833 21.833C21.4426 22.2234 20.8095 22.2231 20.4189 21.833L16.4717 17.8857C14.8398 19.2068 12.7631 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1ZM10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Search
